export enum CUSTOM_ERROR_CODES {
  // TODO: handle all error codes to slack with proper comments
  SLOT_EXPIRED = 'Someone was quicker and this time has been booked out. Please select different time slot.',
  SLOT_EXPIRED_CZ = 'Někdo byl rychlejší a termín rezervoval před vámi. Vyberte prosím nový termín.',
  RESOURCE_DELETED = 'Booking has been already deleted',
  RESOURCE_DELETED_CZ = 'Rezervace již byla zrušena',
}
